export const ActionTypes = {
  LOADING: "CREATE_MS_LOADING",
  ERROR: "CREATE_MS_ERROR",
  SUCCESS: "CREATE_MS_SUCCESS",
};
